











import { Component, Vue, Prop } from 'vue-property-decorator'
import { Location } from 'vue-router'

export interface BreadCrumb {
  text: string | number;
  to?: string | Location;
  disabled?: boolean;
  exact?: boolean;
  href?: string;
  link?: boolean;
}

@Component
export default class BreadCrumbs extends Vue {
  @Prop(Array) readonly items!: Array<BreadCrumb>

  get computedItems (): Array<BreadCrumb> {
    const computedItems = []
    for (let i = 0; i < this.items.length; i++) {
      const item = this.items[i]

      if (item.disabled === undefined) {
        if (i < this.items.length - 1) {
          item.disabled = false
        } else {
          item.disabled = true
        }
      }

      if (item.exact === undefined) {
        item.exact = true
      }

      computedItems.push(item)
    }
    return computedItems
  }
}
